import {useEffect, useRef, useState} from 'react';

function useFocusHeadingAndAnnounce(announce: string) {
  const headingRef = useRef<HTMLHeadingElement>(null);
  const [announcement, setAnnouncement] = useState('');

  useEffect(() => {
    headingRef.current?.focus({preventScroll: true});
  }, []);

  useEffect(() => {
    setAnnouncement(announce);
  }, [announce]);

  return {headingRef, announcement};
}

export {useFocusHeadingAndAnnounce};
